import { RouteParameters } from "./route-parameters";

const COUNTERS_ROUTING = {
  CONFIGURE: `/dashboard/:${RouteParameters.AIRPLANE_ID}/operations/counters/configure`,
  HELP: `/dashboard/:${RouteParameters.AIRPLANE_ID}/operations/counters/help`,
  HISTORY: `/dashboard/:${RouteParameters.AIRPLANE_ID}/operations/counters/history`,
  INPUT: `/dashboard/:${RouteParameters.AIRPLANE_ID}/operations/counters/input`,
  PLOT: `/dashboard/:${RouteParameters.AIRPLANE_ID}/operations/counters/plot`,
  ROOT: `/dashboard/:${RouteParameters.AIRPLANE_ID}/operations/counters`,
} as const;

const COUNTERS_ROUTES = [
  COUNTERS_ROUTING.ROOT,
  COUNTERS_ROUTING.INPUT,
  COUNTERS_ROUTING.PLOT,
  COUNTERS_ROUTING.CONFIGURE,
  COUNTERS_ROUTING.HISTORY,
  COUNTERS_ROUTING.HELP,
] as const;

export { COUNTERS_ROUTES, COUNTERS_ROUTING };
